import React from 'react'; 
import logo from '../../assets/logo.png'
import { useSelector } from 'react-redux';

function ExamHeader({timer,user,exam}) {
  const userL = useSelector(state=>state.auth.user)
  return (
    <div className="exam-header">
      <div className="exam-info">
        <div style={{}}>
        <img src={logo} style={{display:'inline-flex'}} />
        </div>
        <div>
        <h2>Veer Madho Singh Bhandari Uttarakhand Technical University</h2>
        <h3>PhD Entrance Exam</h3>
        </div>
         
         
      </div>
      <div className="candidate-info">
        <p>Candidate: <strong>{userL.name}</strong></p>
        <p>Branch: <strong>{userL.department_name}</strong></p>
        <div className="timer">
          <p>Remaining Time: <strong>{timer}</strong></p>
        </div>
      </div>
    </div>
  );
}

export default ExamHeader;
